import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import routes from '../../helpers/routes';
import common from '../../helpers/common';

export const AuthorizedWrapper = () => {
  const auth = useAuth();

  if (auth.isBackendAuthorized) {
    return <Outlet />;
  }

  return <Navigate to={routes.UN_AUTHENTICATED.LOGIN.PATH} />;
};

export const UnauthorizedWrapper = () => {
  const auth = useAuth();

  if (!auth.isBackendAuthorized) {
    return <Outlet />;
  }

  return <Navigate to={routes.AUTHENTICATED.ROOT.PATH} />;
};


export const AdminWrapper = () => {
  const auth = useAuth();
  const userGroup = localStorage.getItem('master_user_group_id')

  if (auth.isBackendAuthorized && Number(userGroup) === common.USER_GROUP.MASTER_ADMIN) {
    return <Outlet />;
  }

  return <Navigate to={routes.AUTHENTICATED.ROOT.PATH} />;
};
